/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Assign_PickInputs */

const vi_cdo_assign_pick = /** @type {(inputs: Cdo_Assign_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn tài xế`)
};

/**

* @param {Cdo_Assign_PickInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_assign_pick = /** @type {((inputs?: Cdo_Assign_PickInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Assign_PickInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_assign_pick(inputs)
});